module.exports = __webpack_public_path__ + "img/photo-slices.289f7f09.png";